import { router } from "@inertiajs/react"

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"

export const ALL = "all"

type Filters = {
  employeeId: string | null
  projectId: string | null
  status: string | null
}

type Option = { id: string; name: string }

export function TimeFilters({
  employees,
  filters,
  projects,
  statuses,
}: {
  employees: Option[]
  filters: Filters
  projects: Option[]
  statuses: string[]
}) {
  const apply = (next: Partial<Filters>) => {
    const merged = { ...filters, ...next }
    router.get(
      "/team/time",
      {
        employeeId: merged.employeeId ?? undefined,
        projectId: merged.projectId ?? undefined,
        status: merged.status ?? undefined,
      },
      { preserveScroll: true, preserveState: true },
    )
  }

  const toCode = (value: string) => (value === ALL ? null : value)

  return (
    <div className="flex items-center gap-2 border-b border-border px-6 py-2.5">
      <Filter
        label="Employee"
        value={filters.employeeId ?? ALL}
        onChange={(v) => apply({ employeeId: toCode(v) })}
        options={[{ id: ALL, name: "All" }, ...employees]}
      />
      <Filter
        label="Project"
        value={filters.projectId ?? ALL}
        onChange={(v) => apply({ projectId: toCode(v) })}
        options={[{ id: ALL, name: "All" }, ...projects]}
      />
      <Filter
        label="Status"
        value={filters.status ?? ALL}
        onChange={(v) => apply({ status: toCode(v) })}
        options={[{ id: ALL, name: "All" }, ...statuses.map((s) => ({ id: s, name: s }))]}
      />
      <div className="flex-1" />
      <span className="text-label text-muted-foreground">Sorted by date, newest first</span>
    </div>
  )
}

function Filter({
  label,
  onChange,
  options,
  value,
}: {
  label: string
  onChange: (value: string) => void
  options: Option[]
  value: string
}) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="h-8 w-auto gap-1.5 bg-card text-label capitalize">
        <span className="text-muted-foreground">{label}</span>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {options.map((option) => (
          <SelectItem key={option.id} value={option.id} className="capitalize">
            {option.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
